module.exports = __webpack_public_path__ + "static/media/canReverseQuestion.bb1fa3fc.mp3";